export const REQUEST_HERO_BANNER = 'REQUEST_HERO_BANNER';
export const REQUEST_HERO_BANNER_SUCCESS = 'REQUEST_HERO_BANNER_SUCCESS';
export const REQUEST_HERO_BANNER_FAIL = 'REQUEST_HERO_BANNER_FAIL';
export const UPDATE_HERO_BANNER = 'UPDATE_HERO_BANNER';
export const UPDATE_HERO_BANNER_SUCCESS = 'UPDATE_HERO_BANNER_SUCCESS';
export const UPDATE_HERO_BANNER_FAIL = 'UPDATE_HERO_BANNER_FAIL';
export const CREATE_HERO_BANNER = 'CREATE_HERO_BANNER';
export const CREATE_HERO_BANNER_SUCCESS = 'CREATE_HERO_BANNER_SUCCESS';
export const CREATE_HERO_BANNER_FAIL = 'CREATE_HERO_BANNER_FAIL';

export const REQUEST_WEB_CARDS = 'REQUEST_WEB_CARDS';
export const REQUEST_WEB_CARDS_SUCCESS = 'REQUEST_WEB_CARDS_SUCCESS';
export const REQUEST_WEB_CARDS_FAIL = 'REQUEST_WEB_CARDS_FAIL';
export const REQUEST_WEB_CARD = 'REQUEST_WEB_CARD';
export const REQUEST_WEB_CARD_SUCCESS = 'REQUEST_WEB_CARD_SUCCESS';
export const REQUEST_WEB_CARD_FAIL = 'REQUEST_WEB_CARD_FAIL';
export const DELETE_WEB_CARD = 'DELETE_WEB_CARD';
export const DELETE_WEB_CARD_SUCCESS = 'DELETE_WEB_CARD_SUCCESS';
export const DELETE_WEB_CARD_FAIL = 'DELETE_WEB_CARD_FAIL';
export const CREATE_WEB_CARD = 'CREATE_WEB_CARD';
export const CREATE_WEB_CARD_SUCCESS = 'CREATE_WEB_CARD_SUCCESS';
export const CREATE_WEB_CARD_FAIL = 'CREATE_WEB_CARD_FAIL';
export const UPDATE_WEB_CARD = 'UPDATE_WEB_CARD';
export const UPDATE_WEB_CARD_SUCCESS = 'UPDATE_WEB_CARD_SUCCESS';
export const UPDATE_WEB_CARD_FAIL = 'UPDATE_WEB_CARD_FAIL';
export const SORT_WEB_CARD = 'SORT_WEB_CARD';
export const SORT_WEB_CARD_SUCCESS = 'SORT_WEB_CARD_SUCCESS';
export const SORT_WEB_CARD_FAIL = 'SORT_WEB_CARD_FAIL';

export const REQUEST_MEGAPHONE_BANNER = 'REQUEST_MEGAPHONE_BANNER';
export const REQUEST_MEGAPHONE_BANNER_SUCCESS = 'REQUEST_MEGAPHONE_BANNER_SUCCESS';
export const REQUEST_MEGAPHONE_BANNER_FAIL = 'REQUEST_MEGAPHONE_BANNER_FAIL';
export const UPDATE_MEGAPHONE_BANNER = 'UPDATE_MEGAPHONE_BANNER';
export const UPDATE_MEGAPHONE_BANNER_SUCCESS = 'UPDATE_MEGAPHONE_BANNER_SUCCESS';
export const UPDATE_MEGAPHONE_BANNER_FAIL = 'UPDATE_MEGAPHONE_BANNER_FAIL';
export const CREATE_MEGAPHONE_BANNER = 'CREATE_MEGAPHONE_BANNER';
export const CREATE_MEGAPHONE_BANNER_SUCCESS = 'CREATE_MEGAPHONE_BANNER_SUCCESS';
export const CREATE_MEGAPHONE_BANNER_FAIL = 'CREATE_MEGAPHONE_BANNER_FAIL';
